import {
  AutomationActionMicrosoftTeamsInviteToChannelDenormalized,
  IAutomationActionTemplateMicrosoftInviteToChannel,
  MicrosoftTeamsChannelType
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

const CHANNEL_KIND_LABEL_MAP: { [key in MicrosoftTeamsChannelType]: string } = {
  PRIVATE: 'private',
  SHARED: 'shared',
  STANDARD: 'standard'
};

export const ActionSummaryMicrosoftTeamsInviteToChannel = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateMicrosoftInviteToChannel
    | AutomationActionMicrosoftTeamsInviteToChannelDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();

  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {a.channel.type === 'NEW'
            ? t(
                'Create a new **{{ kind }}** channel following the naming schema **{{ channelNameSchema }}** and add **{{ participants }}** to it.',
                {
                  participants:
                    joinWithCommaAndAnd(
                      a.pplToAdd.map((o) =>
                        actionActorToString(o, expTpl.supportingActors, t)
                      ),
                      t
                    ) || 'someone',
                  channelNameSchema: a.channel.nameSchema,
                  kind: CHANNEL_KIND_LABEL_MAP[a.channel.kind]
                }
              )
            : t(
                'Invite **{{ participants }}** to the channel **{{ channelName }}**.',
                {
                  participants:
                    joinWithCommaAndAnd(
                      a.pplToAdd.map((o) =>
                        actionActorToString(o, expTpl.supportingActors, t)
                      ),
                      t
                    ) || 'someone',
                  channelName: `${a.channel.name}`
                }
              )}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
